import { useQuery, useQueries } from "@tanstack/react-query";

import service from "../services/eventsAnalyticsService";
import { recordError } from "../utils/logService";

export const useEventsVenueReportRetrieval = (startDate, endDate, filterId, filterType = "venue") => {
  const enabled = !!startDate && !!endDate && filterId != null;

  const results = useQueries({
    queries: [
      {
        queryKey: ["event-list-report", startDate, endDate, filterId, filterType],
        queryFn: () => service.getEventsByRange("-1", startDate, endDate, filterId),
        enabled,
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["race-events-report", startDate, endDate, filterId, filterType],
        queryFn: () => service.getRace("-1", startDate, endDate, filterId, filterType),
        enabled,
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["gender-events-report", startDate, endDate, filterId, filterType],
        queryFn: () => service.getGender("-1", startDate, endDate, filterId, filterType),
        enabled,
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["age-events-report", startDate, endDate, filterId, filterType],
        queryFn: () => service.getAge("-1", startDate, endDate, filterId, filterType),
        enabled,
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["disability-events-report", startDate, endDate, filterId, filterType],
        queryFn: () => service.getDisability("-1", startDate, endDate, filterId, filterType),
        enabled,
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["participation-type-events-report", startDate, endDate, filterId, filterType],
        queryFn: () => service.getParticipationType("-1", startDate, endDate, filterId, filterType),
        enabled,
        onError: (error) => recordError(error),
      },
    ],
  });

  return {
    eventListData: results[0],
    raceData: results[1],
    genderData: results[2],
    ageData: results[3],
    disabilityData: results[4],
    participationTypeData: results[5],
  };
};

export const useEventsGeoReportRetrieval = (startDate, endDate, filterId, filterType = "venue") => {
  const enabled = !!startDate && !!endDate && filterId != null;

  const results = useQueries({
    queries: [
      {
        queryKey: ["event-geo-province-report", startDate, endDate, filterId, filterType],
        queryFn: () => service.getProvincialDistribution("-1", startDate, endDate, filterId, filterType),
        enabled,
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["venue-geo-municipal-report", startDate, endDate, filterId, filterType],
        queryFn: () => service.getMunicipalDistribution("-1", startDate, endDate, filterId, filterType),
        enabled,
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["venue-geo-provincial-participation-report", startDate, endDate, filterId, filterType],
        queryFn: () => service.getProvincialParticipation("-1", startDate, endDate, filterId, filterType),
        enabled,
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["venue-geo-municipal-participation-report", startDate, endDate, filterId, filterType],
        queryFn: () => service.getMunicipalParticipation("-1", startDate, endDate, filterId, filterType),
        enabled,
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["venue-geo-local-municipal-distribution-report", startDate, endDate, filterId, filterType],
        queryFn: () => service.getLocalMunicipalDistribution("-1", startDate, endDate, filterId, filterType),
        enabled,
        onError: (error) => recordError(error),
      },
    ],
  });

  return {
    provincialDistributionData: results[0],
    municipalDistributionData: results[1],
    provincialParticipationData: results[2],
    municipalParticipationData: results[3],
    localMunicipalDistributionData: results[4],
  };
};

export const useEventsIndividualReportRetrieval = (startDate, endDate) => {
  const results = useQueries({
    queries: [
      {
        queryKey: ["event-individual-report", startDate, endDate],
        queryFn: () => service.getEventsByRange("-1", startDate, endDate),
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["venue-events-report", startDate, endDate],
        queryFn: () => service.getEventsByRange("-1", startDate, endDate),
        onError: (error) => recordError(error),
      },
    ],
  });

  return {
    eventListData: results[0],
  };
};
